import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { OpenAPI } from '@crackpoint/shared/api/generated';
import { API_BASE_URL } from './utils/constants';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './App'

const dsn = import.meta.env.VITE_ADAPTER_MODE === 'client'
  ? import.meta.env.VITE_SENTRY_DSN_INSTANT
  : import.meta.env.VITE_SENTRY_DSN
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}

OpenAPI.BASE = API_BASE_URL;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
